import { render, staticRenderFns } from "./CogLoader.vue?vue&type=template&id=45e355ba"
import script from "./CogLoader.vue?vue&type=script&lang=js"
export * from "./CogLoader.vue?vue&type=script&lang=js"
import style0 from "./CogLoader.vue?vue&type=style&index=0&id=45e355ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports